import { useState } from 'react';
import { styles } from './styles';
import arrowSvg from './logo-arrow.svg';
import { useTranslation } from 'react-i18next';

type NavItem = {
  path: string;
  translationKey: string;
};

export default function NavigationBar() {
  const { t } = useTranslation();
  const [menuVisible, setMenuVisible] = useState(false);

  const handleMenuToggle = () => {
    setMenuVisible((prev) => !prev);
  };

  const navigationItems: NavItem[] = [
    { path: '/fundPrices', translationKey: 'navigation.bar.fund.prices' },
    {
      path: '/fundMarketNews',
      translationKey: 'navigation.bar.fund.market.news'
    },
    { path: '/aboutTheService', translationKey: 'navigation.bar.about.service' }
  ];

  return (
    <styles.NavigationBarWrapper>
      <styles.IconWrapper onClick={handleMenuToggle}>
        <styles.Icon src={arrowSvg} />
      </styles.IconWrapper>
      <styles.NavigationBar className={menuVisible ? 'visible' : ''}>
        {navigationItems.map((item) => (
          <styles.ListElement key={item.path}>
            <styles.ListElementLink to={item.path}>
              {t(item.translationKey)}
            </styles.ListElementLink>
          </styles.ListElement>
        ))}
      </styles.NavigationBar>
    </styles.NavigationBarWrapper>
  );
}
